import { render, staticRenderFns } from "./object-service-config-field.component.vue?vue&type=template&id=6c128dbe&scoped=true"
import script from "./object-service-config-field.component.vue?vue&type=script&lang=ts"
export * from "./object-service-config-field.component.vue?vue&type=script&lang=ts"
import style0 from "./object-service-config-field.component.vue?vue&type=style&index=0&id=6c128dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c128dbe",
  null
  
)

export default component.exports